export default [
  {
    name: 'wa-messenger',
    path: '/wa/messenger',
    component: () => import(/* webpackChunkName: "wa-messenger" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Messenger WhatsApp',
      icon: 'chat',
      label: 'Messenger WhatsApp',
      roles: ['Admin']
    }
  }
]
